import PropTypes from "prop-types";
import React, { Fragment, useState, useEffect } from "react";
import { getProductCartQuantity } from "../../helpers/product";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import Rating from "./sub-components/ProductRating";
import Swiper, { SwiperSlide } from "../../components/swiper";
import { connect } from "react-redux";

function ProductModal(props) {
  const { product } = props;
  const { currency } = props;
  const { discountedprice } = props;
  const { finalproductprice } = props;
  const { finaldiscountedprice } = props;
  const { price } = props;

  const [gallerySwiper, getGallerySwiper] = useState(null);
  const [thumbnailSwiper, getThumbnailSwiper] = useState(null);
  const [selectedProductColor, setSelectedProductColor] = useState(
    product.variation ? product.variation[0].color : ""
  );
  const [selectedProductSize, setSelectedProductSize] = useState(
    product.variation ? product.variation[0].size[0].name : ""
  );
  const [productStock, setProductStock] = useState(
    product.variation ? product.variation[0].size[0].stock : product.stock
  );
  const [quantityCount, setQuantityCount] = useState(1);

  const wishlistItem = props.wishlistitem;
  const compareItem = props.compareitem;

  const addToCart = props.addtocart;
  const addToWishlist = props.addtowishlist;
  const addToCompare = props.addtocompare;

  const addToast = props.addtoast;
  const cartItems = props.cartitems;

  const productCartQty = getProductCartQuantity(
    cartItems,
    product,
    selectedProductColor,
    selectedProductSize
  );

  useEffect(() => {
    if (
      gallerySwiper !== null &&
      gallerySwiper.controller &&
      thumbnailSwiper !== null &&
      thumbnailSwiper.controller
    ) {
      gallerySwiper.controller.control = thumbnailSwiper;
      thumbnailSwiper.controller.control = gallerySwiper;
    }
  }, [gallerySwiper, thumbnailSwiper]);

  const gallerySwiperParams = {
    getSwiper: getGallerySwiper,
    spaceBetween: 10,
    loopedSlides: 4,
    loop: false
  };

  const thumbnailSwiperParams = {
    getSwiper: getThumbnailSwiper,
    spaceBetween: 10,
    slidesPerView: 4,
    loopedSlides: 4,
    touchRatio: 0.2,
    freeMode: true,
    loop: false,
    slideToClickedSlide: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    renderPrevButton: () => (
      <button className="swiper-button-prev ht-swiper-button-nav">
        <i className="pe-7s-angle-left" />
      </button>
    ),
    renderNextButton: () => (
      <button className="swiper-button-next ht-swiper-button-nav">
        <i className="pe-7s-angle-right" />
      </button>
    )
  };

  const colorChecker = (data) => {
    return data
  }

  useEffect(() => {
    setSelectedProductColor(selectedProductColor);
    // colorChecker(selectedProductColor)
  }, [selectedProductColor]);

  const getImages = () => {
    const showImages = []
    const images = product?.data?.mediaData?.media?.filter(image => image.color === selectedProductColor && image.url !== null && image.classTypeArray[0].classTypeName !== 'Swatch' && image.classTypeArray[0].classTypeName !== 'Primary' && image.url.indexOf('.gif') === -1)
    images && images.forEach(url => { showImages.push(url.url)})
    return showImages.length > 1 ? showImages : [product?.data?.productData?.primaryImageUrl]
  }

  return (
    <Fragment>
      <Modal
        show={props.show}
        onHide={props.onHide}
        className="product-quickview-modal-wrapper"
      >
        <Modal.Header closeButton></Modal.Header>

        <div className="modal-body">
          <div className="row">
            <div className="col-md-5 col-sm-12 col-xs-12">
            <div className="product-large-image-wrapper">
        {product.discount || product.new ? (
          <div className="product-img-badges">
            {product.discount ? (
              <span className="pink">-{product.discount}%</span>
            ) : (
              ""
            )}
            {product.new ? <span className="purple">New</span> : ""}
          </div>
        ) : (
          ""
        )}
          <Swiper options={gallerySwiperParams} >
            {getImages().map((single, key) => (
              <SwiperSlide key={key}>
                <div className="single-image">
                  <img
                    src={single}
                    style={{width: '600px', height: '800px', objectFit: 'contain' }}
                    className="img-fluid"
                    alt=""
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
      </div>
            </div>
            <div className="col-md-7 col-sm-12 col-xs-12">
              <div className="product-details-content quickview-content">
                <h5>{product?.data?.productData?.productId} </h5>
                <h2>{product?.data?.productData?.productName}</h2>
                <div className="product-details-price">
                    <Fragment>
                      <span>
                        <span>Starting at:</span> <b>{price}</b>
                      </span>{" "}
                    </Fragment>
                </div>
                
                <hr />
                {product ? (
                  <div className="pro-details-size-color">
      <div className="pro-details-size-color">
      <div className="pro-details-size">
            <span>Colors</span>
            <div className="pro-details-size-content">
            {product?.data?.productData?.colorsHex?.map((single, key) => {
                        return (
                          <label
                          style={{ margin: '7px', pointerEvents: 'none' }}
                            className={`pro-details-size-content--single`}
                            key={key}
                          >
                            <input
                              type="radio"
                              value={selectedProductColor}
                              name="product-size"
                              disabled
                              checked={
                                single.colorName === selectedProductColor ? "checked" : ""
                              }
                              onChange={() => {
                                setSelectedProductColor(single.colorName);
                              //  setSelectedProductSize(single.size[0].name);
                              //  setProductStock(single.size[0].stock);
                              }}
                            />
                            <span className="size-name">{single.colorName}</span>
                          </label>
                        );
                      })
                }
            </div>
          </div>
          </div>
                  </div>
                ) : (
                  ""
                )}
                <hr />
                <ul className="popup-list" style={{ listStyleType: 'square', paddingLeft: '20px', paddingRight: '20px' }}>
                {product?.data?.productData?.description ? product?.data?.productData?.description?.map(item => {
            return (
              <li>{item}</li>
            )
          }) : <li>{product?.data?.productData?.descriptionText}</li>}
                  </ul>

                {product.affiliateLink ? (
                  <div className="pro-details-quality">
                    <div className="pro-details-cart btn-hover">
                      <a
                        href={product.affiliateLink}
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        Buy Now
                      </a>
                    </div>
                  </div>
                ) : (
                  <div className="pro-details-quality">
                    <div className="pro-details-cart btn-hover">
                      
                        <button
                        onClick={() => window.location.href = "/product/" + product.id}
                        >
                          {" "}
                          View Product Detail{" "}
                        </button>
                    </div>
                    {/* <div className="pro-details-wishlist">
                      <button
                        className={wishlistItem !== undefined ? "active" : ""}
                        disabled={wishlistItem !== undefined}
                        title={
                          wishlistItem !== undefined
                            ? "Added to wishlist"
                            : "Add to wishlist"
                        }
                        onClick={() => addToWishlist(product, addToast)}
                      >
                        <i className="pe-7s-like" />
                      </button>
                    </div> */}
                    {/* <div className="pro-details-compare">
                      <button
                        className={compareItem !== undefined ? "active" : ""}
                        disabled={compareItem !== undefined}
                        title={
                          compareItem !== undefined
                            ? "Added to compare"
                            : "Add to compare"
                        }
                        onClick={() => addToCompare(product, addToast)}
                      >
                        <i className="pe-7s-shuffle" />
                      </button>
                    </div> */}
                  </div>
                )}
              </div>
            </div>
          </div>
          {/* <hr /> */}
          {/* <div className="row pl-3">
            <Link to={'https://google.com'}><i class="fa fa-twitter ml-2" style={{ fontSize: '25px' }}></i></Link>
            <Link to={'https://google.com'}><i class="fa fa-facebook ml-2" style={{ fontSize: '25px' }}></i></Link>
            <Link to={'https://google.com'}><i class="fa fa-pinterest ml-2" style={{ fontSize: '25px' }}></i></Link>
          </div> */}
        </div>
      </Modal>
    </Fragment>
  );
}

ProductModal.propTypes = {
  addtoast: PropTypes.func,
  addtocart: PropTypes.func,
  addtocompare: PropTypes.func,
  addtowishlist: PropTypes.func,
  cartitems: PropTypes.array,
  compareitem: PropTypes.object,
  currency: PropTypes.object,
  discountedprice: PropTypes.number,
  finaldiscountedprice: PropTypes.number,
  finalproductprice: PropTypes.number,
  onHide: PropTypes.func,
  product: PropTypes.object,
  show: PropTypes.bool,
  wishlistitem: PropTypes.object
};

const mapStateToProps = state => {
  return {
    cartitems: state.cartData
  };
};

export default connect(mapStateToProps)(ProductModal);
